/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useEffect } from "react";
import './../App.css'
import './companies.css'
import { useNavigate } from 'react-router-dom'
import { getCompanies } from "./utils/dataRequests";
import { buildTable } from "./utils/table.js";
import { isDev } from "./utils/helper.js";
import { isMobile } from "react-device-detect";
import 'jquery';


const Companies = () => {
    const navigate = useNavigate();
    let count = 0;
    let _isDev = isDev();
    console.log('Companies page loaded');
    let accessToken = sessionStorage.getItem("accessToken");
    let companiesJson;

    useEffect(() => {

        count = count + 1;
        console.log("On page load: " + count);
        if (count === 1 && _isDev) {
            return;
        }
        if (!accessToken) {
            navigate('/sign-in');
            return;
        } else if (!sessionStorage.getItem("accessToken")) {
            return;
        }
        console.log("On page load");

        if (isMobile) {
        }

        getCompanies((_companiesJson) => {
            if (_companiesJson) {
                companiesJson = _companiesJson;
                buildTable("companies-container", ["Name", "Address"], ["name", "address"], companiesJson, navigate, "_id", "/companies/", "/groups/");
            }
        }, accessToken);
    }, [count]);

    return (
        <>
            <h2>Companies</h2>
            <nav id="sidebarMenu" className="collapse d-lg-block sidebar bg-white">
                <div className="position-sticky">
                    <div className="list-group list-group-flush mx-3 mt-4">
                        <a href="/create-company" className="list-group-item list-group-item-action py-2 ripple">
                            <i className="fas fa-lock fa-fw me-3"></i><span>Create company</span>
                        </a>
                    </div>
                </div>
            </nav>
            <div className="content-box">  {/* This creates the white box */}
                <div id="companies-container"></div>  {/* This just holds the table */}
            </div>
        </>
    );
}

export default Companies;
